/**
 * urlUtil  url 配置
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */


export const BaseUrl = 'https://proxy.yunlsp.com' //正式的请求地址
export const testUrl = 'http://proxy.yunlsp.com/gateway-test' // 测试地址
export const testUrlBack = ''
export const elevenActivityUrl = '/truck/activity/group' // 双11活动url
export const shopBaseUrl = '/shop'
export const truckBaseUrl = '/truck/api'
export const truckActivityUrl = '/truck/activity' // 活动url